import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useDialogtyles = makeStyles(
  (theme: Theme) => {
    return {
      dialog: {
        '& .v5-MuiPaper-root': {
          borderRadius: '1rem',
        },
      },
      title: {
        padding: theme.spacing(2),
        '&.v5-MuiDialogTitle-root': {
          fontSize: '1.5rem',
          fontWeight: '400',
          lineHeight: '2rem',
          margin: 0,
        },
      },
      closeButton: {
        right: '0.5rem',
        top: '0.75rem',
        '&.v5-MuiIconButton-sizeMedium': {
          position: 'absolute',
          color: theme.palette.grey[500],
        },
      },
      contentBox: {
        padding: '1rem',
        fontSize: '.875rem',
        color: theme.palette.mode === 'dark' ? '#fff' : '#333',
        '&::-webkit-scrollbar': {
          backgroundColor: theme.palette.background.default,
          scrollbarWidth: 'thin',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: theme.palette.background.default,
          borderLeft: `1px solid ${theme.palette.divider}`,
        },
        '&::-webkit-scrollbar-thumb': {
          maxWidth: '4px',
          backgroundColor: '#757575',
          borderRadius: '10px',
          border: `2px solid ${theme.palette.background.default}`,
        },
      },
      actions: {
        padding: theme.spacing(2),
      },
    };
  },
  { name: 'Dialog' },
);
